export function getShopDefaultQuantity(minimumQuantity, incrementQuantity, quantityInCart = 0) {
  const cartQty = Number(quantityInCart) || 0;
  if (cartQty > 0) {
    return cartQty;
  }

  const min = Number(minimumQuantity) || 1;
  const inc = Number(incrementQuantity) || 1;

  if (inc > 1 && min > 1 && (min % inc)) {
    return min;
  }
  if (inc > 1 && min <= 1) {
    return inc;
  }
  if (inc <= 1 && min > 1) {
    return min;
  }
  if (inc > 1 && min > 1) {
    return min;
  }
  return 1;
}

export function getShopQuantityFloor(minimumQuantity, incrementQuantity) {
  return getShopDefaultQuantity(minimumQuantity, incrementQuantity, 0);
}
